export const initialState = {
  attributes: [],
  availableAttributes: []
};

export default { ...initialState };
